<div #mainDiv_ll_model_cash_switch>


  <!-- TABS ACROSS THE TOP-->
  <div [hidden]="!bundle.showHorzTabs"
       [style.top.px]="bundle.horzTabsY"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       [style.height.px]="bundle.remainingH"
       style="position: absolute;z-index:100">

    <div *ngFor="let item of bundle.horzTabs; let i = index"
         style="float:left; white-space:nowrap; cursor:pointer;"
         (click)="selectTab(item.LABEL)">

       <!--Active tab--> 
      <div *ngIf="item.LABEL === bundle.activeCODE"
           class="wordBtn14_selected"
           style="float: left; padding-right: 30px; box-sizing: border-box;">
        {{ item.LABEL }}
      </div>

       <!--Inactive tab--> 
      <div *ngIf="item.LABEL !== bundle.activeCODE"
           class="wordBtn14"
           style="float: left; padding-right: 30px; box-sizing: border-box;">
        {{ item.LABEL }}
      </div>

    </div>


  </div>




  <div *ngIf="bundle.showRemaining"
       [hidden]="bundle.mode != ''"
       [style.top.px]="bundle.remainingY"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       [style.height.px]="bundle.remainingH"
       style="position: absolute; z-index: 100">

    <ll-model-cash-upload *ngIf="bundle.activeCODE == 'Bank-Cash-Uploads' "></ll-model-cash-upload>
    <ll-model-cash *ngIf="bundle.activeCODE == 'Bank-Cash-Lists' " id="ll-model-cash"></ll-model-cash>
    <ll-model-cash-rules *ngIf="bundle.activeCODE == 'Bank-Cash-Rules' "></ll-model-cash-rules>
    <!--<ll-model-cash-rules *ngIf="bundle.activeCODE == 'Bank-Accounts' "></ll-model-cash-rules>-->

    <ll-model-cash-reconcile-switch *ngIf="bundle.activeCODE == 'Remit-Cash-Reconcile' "></ll-model-cash-reconcile-switch>
    <ll-admin-generic-dg *ngIf="bundle.activeCODE == 'Cash-Projection'" id="model_cash_projections"></ll-admin-generic-dg>
  </div>

  <div *ngIf="bundle.mode == 'editCashRule' "
       [style.top.px]="bundle.remainingY + 10"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       [style.height.px]="bundle.remainingH"
       style="position: absolute; z-index: 100">

    <div class="wordBtnGroup">
      <img class="btnIcon" height=23 style="width: auto;" src="assets/icon_backArrow.png" alt="" (click)="clearMode() ">
      <div class="wordBtn14" style="padding-left:5px; padding-top:3px;" (click)="clearMode() ">Go Back</div>
    </div>

    <ll-model-cash-rule-edit></ll-model-cash-rule-edit>
  </div>





</div>
